module.exports = __webpack_public_path__ + "static/media/facebookIcon.059f0e50.png";